export default {
  footer: {
    meta: [
      {
        name: '© 2019 Mercedes-Benz Schweiz AG',
        url: 'https://www.mercedes-benz.ch/de/passengercars/content-pool/tool-pages/legal/copyright.html',
      },
      {
        name: 'Cookies',
        url: 'https://www.mercedes-benz.ch/de/passengercars/content-pool/tool-pages/legal/cookies.html',
      },
      {
        name: 'Datenschutz Schweiz',
        url: 'https://www.mercedes-benz.ch/de/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html',
      },
      {
        name: 'Datenschutz Liechtenstein',
        url: 'https://www.mercedes-benz.ch/de/passengercars/content-pool/tool-pages/legal/privacy-statement-liechtenstein.html',
      },
      { name: 'Rechtliche Hinweise',
        url: 'https://www.mercedes-benz.ch/de/passengercars/content-pool/tool-pages/legal/legal-notice.html',
      },
    ],
  },
  registration: {
    breadcrumb: 'Mercedes-Benz Parking.',
    title: 'Registrieren Sie sich jetzt für Mercedes-Benz Parking.',
    form: {
      title: [
        { value: 'mr', name: 'Herr' },
        { value: 'mrs', name: 'Frau' },
      ],
      firstname: 'Vorname',
      lastname: 'Nachname',
      street: 'Strasse',
      streetnr: 'Hausnummer',
      zip: 'PLZ',
      city: 'Ort',
      email: 'E-Mail-Adresse',
      mobile: 'Mobiltelefonnummer',
      plate: 'Kennzeichen',
      model: {
        placeholder: 'Fahrzeugmodell',
        hint: 'Es können ausschliesslich Mercedes-Benz Fahrzeuge bei Mercedes-Benz Parking parkiert werden.',
        options: [
          { value: 'A-Klasse' },
          { value: 'B-Klasse' },
          { value: 'C-Klasse' },
          { value: 'E-Klasse' },
          { value: 'S-Klasse' },
          { value: 'CLA' },
          { value: 'CLS' },
          { value: 'G-Klasse' },
          { value: 'GLA' },
          { value: 'GLC' },
          { value: 'GLE' },
          { value: 'GLS' },
          { value: 'AMG GT' },
          { value: 'AMG GT 4-Türer' },
          { value: 'SL' },
          { value: 'SLC' },
          { value: 'V-Klasse' },
          { value: 'X-Klasse' },
          { value: 'Andere' },
        ],
      },
      info: {
        title: 'Datenspeicherung und -nutzung',
        copy: 'Wir würden Sie gerne weiterhin beraten, betreuen und informieren. Dafür benötigen wir Ihre datenschutzrechtliche Einwilligung zur Speicherung und Nutzung Ihrer Daten. Die von Ihnen ausgewählten Einstellungen können jederzeit geändert werden.',
      },
      consent: {
        title: 'Datenschutzrechtliche Einverständniserklärung lesen',
        copy: 'Ich bin damit einverstanden, dass die Daten, die im Rahmen dieser Kontaktaufnahme erhoben werden, durch die Daimler AG, die Vertriebsgesellschaft Mercedes-Benz Schweiz AG, die zuständigen Vertretungen innerhalb der Daimler Vertriebsorganisation und die My Driver GmbH zu meiner Beratung, Betreuung und Information über Produkte und Dienstleistungen sowie ähnliche Aktivitäten der Daimler Gruppe per Post, Telefon, Fax und E-Mail verarbeitet und genutzt werden dürfen. Zu diesen Zwecken können die Daten auch an das Daimler Customer Assistance Center N.V. Maastricht übermittelt werden. Wenn Sie der Verarbeitung und Nutzung Ihrer Daten später widersprechen möchten, wenden Sie sich bitte an Mercedes-Benz Schweiz AG, Bernstrasse 55, 8952 Schlieren. Dies schränkt unsere Möglichkeiten, Sie zu betreuen und zu informieren, allerdings ein.',
      },
      terms: {
        text: 'Ich bin mit der Erklärung einverstanden und stimme der Speicherung und Nutzung meiner Daten für die folgenden Kanäle zu:*',
        options: [
          {
            id: 'mail',
            title: 'Post*',
            values: [
              { value: true, name: 'Ja' },
              { value: false, name: 'Nein' },
            ],
          },
          {
            id: 'email',
            title: 'Elektronische Post*',
            values: [
              { value: true, name: 'Ja' },
              { value: false, name: 'Nein' },
            ],
          },
          {
            id: 'phone',
            title: 'Telefon*',
            values: [
              { value: true, name: 'Ja' },
              { value: false, name: 'Nein' },
            ],
          },
        ],
      },
      required: '*Pflichtfeld',
      submit: 'Registrieren',
      errors: {
        empty: 'Dieses Feld ist ein Pflichtfeld.',
        invalid: '{0} ist ungültig.',
      },
    },
  },
  thanks: {
    title: 'Herzlichen Dank.',
    copy: 'Ihre Anmeldung wurde übermittelt. Sie erhalten in den nächsten Minuten eine E-Mail mit einem Bestätigungslink zum Abschluss Ihrer Registrierung.',
  },
  confirmation: {
    title: 'Ihre Registrierung ist abgeschlossen.',
    copy: 'Herzlichen Dank für Ihre erfolgreiche Registrierung bei Mercedes-Benz Parking. Sie können dieses Fenster schliessen.',
  },
  valet: {
    login: {
      user: 'Username',
      pass: 'Passwort',
      button: 'Login',
    },
    overview: {
      newclientreg: 'Neuen Kunden registrieren',
      plate: 'Kennzeichen eingeben',
      checkins: 'Parkliste',
    },
    list: {
      plate: 'Kennzeichen',
      firstname: 'Vorname',
      lastname: 'Nachname',
      confirmed: 'Double-Opt-In',
      details: 'Details',
      checkin: 'Check-in',
      checkout: 'Check-out',
    },
    details: {
      breadcrumb: 'Details',
      title: {
        placeholder: 'Anrede',
        mr: 'Herr',
        mrs: 'Frau',
      },
      confirmed: {
        true: 'Bestätigt',
        false: 'Nicht bestätigt',
      },
      checkin: 'Check-in-Zeit',
      comment: 'Kommentar',
      edit: 'Bearbeiten',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      modal: {
        title: 'Eintrag löschen',
        description: 'Sind Sie sicher dass Sie diesen Eintrag löschen möchten?<br/> Diese Aktion kann nicht rückgängig gemacht werden.',
      },
    },
    checkins: {
      breadcrumb: 'Check-ins / Check-outs',
      checkin: 'Check-in-Zeit',
      checkout: 'Check-out-Zeit',
      duration: 'Aufenthaltsdauer',
    },
    edit: {
      breadcrumb: 'Eintrag bearbeiten',
      confirmed: [
        { value: true, name: 'bestätigt' },
        { value: false, name: 'nicht bestätigt' },
      ],
    },
    registration: {
      breadcrumb: 'Registrieren und Check-in',
      submit: 'Registrieren und Check-In',
    },
  },
  banners: {
    cookies: {
      title: 'Wir verwenden Cookies',
      body: '<p>Wir verwenden Cookies, Tracking- und (Re-)Targeting-Technologien.<p><p>Damit wollen wir unsere Webseiten nutzerfreundlicher gestalten und fortlaufend verbessern sowie passende Angebote und Werbung für dich anzuzeigen. Wenn du die Webseite weiter nutzt, stimmst du dadurch der Verwendung von Cookies zu.</p><p>Weitere Informationen und Entscheidungsmöglichkeiten erhalten Sie in unseren <a href="https://www.mercedes-benz.ch/de/passengercars/content-pool/tool-pages/legal/cookies.html" target="_blank">Datenschutz - und Cookie-Hinweisen</a>.</p>',
    },
  },
};
